export interface NetworkInfo {
  name: string;
  fee: number;
  time: string;
}

export interface CryptoAsset {
  symbol: string;
  name: string;
  nameAr: string;
  price: number;
  sellPrice: number;
  change24h: number;
  icon: string;
  image?: string;
  color: string;
  networks: NetworkInfo[];
  market_cap_rank?: number;
}

const PROFIT_MARGIN = 1.20;

// Only Ethereum (ERC20) is supported as the single network for send/receive
const ERC20_NETWORK: NetworkInfo = { name: "Ethereum (ERC20)", fee: 8.00, time: "5-15 دقيقة" };

// Known crypto metadata — restricted to Ethereum-only assets
export const KNOWN_CRYPTO_META: Record<string, {
  icon: string; nameAr: string; nameEn: string; color: string; networks: NetworkInfo[]
}> = {
  ETH: {
    icon: "Ξ", nameAr: "إيثيريوم", nameEn: "Ethereum", color: "hsl(var(--crypto-purple))",
    networks: [ERC20_NETWORK],
  },
};


// Default network for unknown coins
const DEFAULT_NETWORKS: NetworkInfo[] = [ERC20_NETWORK];

// Color palette for coins without known meta
const COLOR_PALETTE = [
  "hsl(var(--crypto-blue))",
  "hsl(var(--crypto-purple))",
  "hsl(var(--crypto-green))",
  "hsl(var(--crypto-gold))",
  "hsl(var(--crypto-red))",
];

export function buildCryptoAsset(data: {
  symbol: string;
  name: string;
  price: number;
  sellPrice: number;
  change24h: number;
  image?: string;
  market_cap_rank?: number;
}): CryptoAsset {
  const meta = KNOWN_CRYPTO_META[data.symbol];
  const colorIndex = data.symbol.charCodeAt(0) % COLOR_PALETTE.length;
  
  return {
    symbol: data.symbol,
    name: data.name,
    nameAr: meta?.nameAr || data.name,
    price: data.price,
    sellPrice: data.sellPrice,
    change24h: data.change24h,
    icon: meta?.icon || data.symbol.charAt(0),
    image: data.image,
    color: meta?.color || COLOR_PALETTE[colorIndex],
    networks: meta?.networks || DEFAULT_NETWORKS,
    market_cap_rank: data.market_cap_rank,
  };
}

// Fallback static assets (used when API fails completely)
export const cryptoAssets: CryptoAsset[] = [
  buildCryptoAsset({ symbol: "ETH", name: "Ethereum", price: 3456.78, sellPrice: 3456.78 * PROFIT_MARGIN, change24h: 1.56 }),
];


export const formatCurrency = (amount: number, currency: string = "USD"): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatCrypto = (amount: number): string => {
  return amount.toFixed(8).replace(/\.?0+$/, "");
};
